<template>
  <div class="container w-100-mobile">
    <div class="row center-xs" v-if="!showThankYouPage">
      <div class="col-sm-7 col-xs-12 pt20">
        <div>
          <h3>Арсенал страхування</h3>
        </div>
        <div class="col-md-12 col-xs-12 p0">
          <promo-item v-if="partner && partner.hasOwnProperty('promotions')"/>
        </div>
        <div class="fs18 start-md start-xs">
          <p>СК «АРСЕНАЛ СТРАХУВАННЯ» надає широкий спектр страхових послуг серед яких КАСКО і ОСЦПВ («Автоцивілка»), страхування майна, іпотеки, вантажів, медичне страхування, страхування від нещасного випадку, страхування дронів та багато інших.</p>
          <p class="center-md center-xs">Заповніть форму і наш консультант Вам зателефонує.</p>
        </div>
        <div class="col-xs-12 col-sm-12 insurance" v-if="productInsurance.length">
          <base-select
            class="mb10"
            name="countries"
            :options="productSelect"
            :selected="selectedInsurance"
            :placeholder="$t('Choose insurance*')"
            :validations="[
              {
              condition: $v.selectedInsurance.$error && !$v.selectedInsurance.required,
              text: $t('Field is required')
              }
            ]"
            @blur="$v.selectedInsurance.$touch()"
            @change="$v.selectedInsurance.$touch(); saveInStorage()"
            v-model="selectedInsurance"
            autocomplete="country-name"
          />
          <div style="min-height: 40px;" >
            <div v-if="selectedInsuranceDescription" v-html="selectedInsuranceDescription" class="insurance-description"></div>
          </div>
        </div>
        <base-input
          class="col-xs-12 col-md-12"
          type="text"
          name="first-name"
          :placeholder="$t('First name *')"
          v-model.trim="personalDetails.firstName"
          @blur="$v.personalDetails.firstName.$touch()"
          autocomplete="given-name"
          :validations="[
                {
                  condition: $v.personalDetails.firstName.$error && !$v.personalDetails.firstName.required,
                  text: $t('Field is required')
                },
                {
                  condition: !$v.personalDetails.firstName.minLength,
                  text: $t('Name must have at least 2 letters.')
                }
              ]"
          @input="saveInStorage()"
        />

        <base-input
          class="col-xs-12 col-md-12"
          type="text"
          name="last-name"
          :placeholder="$t('Last name *')"
          v-model.trim="personalDetails.lastName"
          @blur="$v.personalDetails.lastName.$touch()"
          autocomplete="family-name"
          :validations="[{
                condition: $v.personalDetails.lastName.$error && !$v.personalDetails.lastName.required,
                text: $t('Field is required')
              }]"
          @input="saveInStorage()"
        />

        <base-telephone-input
          class="col-xs-12"
          :required="true"
          :validations="phoneValidations"
          :value="personalDetails.phoneNumber"
          @update="updatePhoneNumber"
          @input="$v.personalDetails.phoneNumber.$touch()"
        />

        <base-input
          class="col-xs-12"
          type="email"
          name="email-address"
          :placeholder="$t('Email address *')"
          v-model="personalDetails.emailAddress"
          @blur="$v.personalDetails.emailAddress.$touch()"
          autocomplete="email"
          :validations="[
                {
                  condition: $v.personalDetails.emailAddress.$error && !$v.personalDetails.emailAddress.required,
                  text: $t('Field is required')
                },
                {
                  condition: !$v.personalDetails.emailAddress.email && $v.personalDetails.emailAddress.$error,
                  text: $t('Please provide valid e-mail address.')
                }
              ]"
          @input="saveInStorage()"
        />
        <div class="col-xs-12 col-sm-12 mt10">
          <div class="col-xs-12 col-md-8" style="margin: auto">
            <slot name="placeOrderButton">
              <button-full
                @click.native="placeOrder()"
                data-testid="orderReviewSubmit"
                class="place-order-btn"
                :disabled="$v.$invalid"
              >
                Оформити
              </button-full>
            </slot>
          </div>
        </div>
        <div class="fs18 start-md start-xs">
          <p>СК «АРСЕНАЛ СТРАХУВАННЯ» - компанія зі 100%-м українським капіталом, яка входить до ТОП-5 страховиків України.</p>
          <p>Саме «АРСЕНАЛ СТРАХУВАННЯ» обрали понад 350 тисяч клієнтів по всій країні за оперативність та якість страхових виплат. Середній термін виплати страхового відшкодування становить близько 5-ти робочих днів, а щодня компанія відшкодовує своїм клієнтам понад 3 млн. грн. збитків.</p>
          <p>Компанія представлена в усіх обласних центрах України, і має понад 50 підрозділів.</p>
        </div>
      </div>
    </div>
    <thank-you-page v-else/>
  </div>
</template>

<script>
import { required, minLength, email } from 'vuelidate/lib/validators'
import BaseSelect from "../components/core/blocks/Form/BaseSelect";
import ThankYouPage from "../components/theme/blocks/PickupCheckout/ThankYouPage";
import ButtonFull from "../components/theme/ButtonFull";
import PromoItem from "../components/core/blocks/Shop/Product/PromoItem";

const BaseInput = () => import(/* webpackChunkName: "vsf-base-input" */ 'theme/components/core/blocks/Form/BaseInput');
const BaseTelephoneInput = () => import(/* webpackChunkName: "vsf-base-telephone-input" */ 'theme/components/core/blocks/Form/BaseTelephoneInput.vue');

export default {
  name: 'Insurance',
  components: {
    ThankYouPage,
    BaseInput,
    BaseSelect,
    ButtonFull,
    PromoItem,
    BaseTelephoneInput
  },
  async mounted () {
    await this.$store.dispatch('partners/ensureCurrentPartner', { code: this.$route.name, locationCode: this.$route.params.locationCode });
    let userInfo = JSON.parse(localStorage.getItem('shop/user/insurance'))
    if (userInfo && userInfo.hasOwnProperty('firstName') && userInfo.firstName) {
      let phone = this.checkPhoneCountry(userInfo.phoneNumber)
      this.personalDetails.firstName = userInfo.firstName ? userInfo.firstName : ''
      this.personalDetails.lastName = userInfo.lastName ? userInfo.lastName : ''
      this.personalDetails.phoneNumber = phone
      this.personalDetails.emailAddress = userInfo.emailAddress ? userInfo.emailAddress : ''
      this.selectedInsurance = userInfo.insurance ? userInfo.insurance : ''
    } else if (this.user && this.user.hasOwnProperty('id') && this.user.id) {
      let phone = this.checkPhoneCountry(this.user.telephone)
      this.personalDetails.firstName = this.user.firstname ? this.user.firstname : ''
      this.personalDetails.lastName = this.user.lastname ? this.user.lastname : ''
      this.personalDetails.phoneNumber = phone
      this.personalDetails.emailAddress = this.user.email ? this.user.email : ''
    }
  },
  data () {
    return {
      personalDetails: {
        firstName: '',
        lastName: '',
        phoneNumber: '',
        emailAddress: ''
      },
      selectedInsurance: '',
      showThankYouPage: false,
      phoneMeta: {
        isValid: false
      }
    }
  },
  validations () {
    return {
      personalDetails: {
        firstName: {
          required,
          minLength: minLength(2)
        },
        lastName: {
          required
        },
        phoneNumber: {
          required: () => required && 'phoneNumber' in this.phoneMeta,
          isValid: () => this.phoneMeta.isValid
        },
        emailAddress: {
          required,
          email
        }
      },
      selectedInsurance: {
        required
      }
    }
  },
  computed: {
    phoneValidations () {
      return [
        {
          condition: this.$v.personalDetails.phoneNumber.$error && !this.$v.personalDetails.phoneNumber.required,
          text: this.$t('Field is required.')
        },
        {
          condition: this.$v.personalDetails.phoneNumber.$error && this.$v.personalDetails.phoneNumber.required && !this.$v.personalDetails.phoneNumber.isValid,
          text: this.$t('Incorrect type of number')
        }
      ]
    },
    selectedInsuranceDescription () {
      return this.selectedInsurance? this.productSelect.find(el => el.value === this.selectedInsurance).description : ''
    },
    productInsurance () {
      if (this.$store.getters['partners/getCurrentPartner'] && this.$store.getters['partners/getCurrentPartner'].hasOwnProperty('root_category_id')) {
        let category = this.$store.getters['products_categories/categoriesProducts'].find(category => category.categoryIds === this.$store.getters['partners/getCurrentPartner'].root_category_id)
        return category && category.hasOwnProperty('products') ? category.products : []
      }
      return []
    },
    productSelect () {
      return this.productInsurance.length
        ? this.productInsurance.map(product => {
          let currentProduct = product._source
          return {
            label: currentProduct.price > 0 ? `${currentProduct.name} (${currentProduct.price} ${$t('UAH')}})`: currentProduct.name,
            value: currentProduct.sku,
            description: currentProduct.description
          }
        })
        : []
    },
    partner () {
      return this.$store.getters['partners/getCurrentPartner'];
    },
    user () {
      return this.$store.getters['user/getCurrentUser']
    }
  },
  watch: {
    partner: {
      async handler () {
        if (this.partner && this.partner.code === 'insurance') {
          let category = await this.$store.dispatch('products_categories/setCategories', { store: this.partner.code, location_code: this.partner.location_code, size: 12, id: 1 })
          this.$store.dispatch('products_categories/updateProducts', { store: this.partner.code, location_code: this.partner.location_code, size: 12, categoryIds: this.partner.root_category_id, category })
        }
      }
    },
    user: {
      handler () {
        if (this.user && this.user.hasOwnProperty('id') && this.user.id) {
          let phone = this.checkPhoneCountry(this.user.telephone)
          this.personalDetails.firstName = this.user.firstname ? this.user.firstname : ''
          this.personalDetails.lastName = this.user.lastname ? this.user.lastname : ''
          this.personalDetails.phoneNumber = phone
          this.personalDetails.emailAddress = this.user.email ? this.user.email : ''
        }
      }
    }
  },
  methods: {
    updatePhoneNumber (value) {
      this.phoneMeta = value;

      if ('formattedNumber' in value) {
        this.personalDetails.phoneNumber = value.formattedNumber;
      }

      this.saveInStorage();
    },
    placeOrder () {
      if (this.$v.$invalid) {
        this.$v.$touch();
        this.$store.dispatch('notification/spawnNotification', {
          type: 'error',
          message: this.$t('Please fix the validation errors'),
          action1: { label: this.$t('OK') }
        })
        return
      } else {
        let city = this.partner.location_code.charAt(0).toUpperCase() + this.partner.location_code.slice(1);
        let order = {
          user_id: this.$store.state.user.current ? this.$store.state.user.current.id.toString() : '',
          partner_code: this.partner.code,
          location_code: this.partner.location_code,
          comments: '',
          is_asap: true,
          contactToReplace: false,
          addressInformation: {
            billingAddress: {
              city: city,
              country: "Ukraine",
              email: this.personalDetails.emailAddress,
              firstname: this.personalDetails.firstName,
              lastname: this.personalDetails.lastName,
              postcode: '46000',
              state: city,
              region_code: "",
              region_id: 0,
              street: ["вул. С. Крушельницької, 55", "61"],
              phone_number: "+38" + this.personalDetails.phoneNumber
            },
            shipping_method_code: 'anywhere',
            shipping_carrier_code: 'anywhere',
            payment_method_code: 'cash',
          }
        }
        order.items = []
        let product = this.productInsurance.find(product => product._source.sku === this.selectedInsurance)._source
        product.qty = 1
        order.items.push(product);
        order.comments = [{
          comment: "",
          partner: this.partner.code
        }]
        order.addressInformation.shippingAddress = {
          city: city,
          company: "NA",
          country: "Ukraine",
          email: this.personalDetails.emailAddress,
          firstname: this.personalDetails.firstName,
          lastname: this.personalDetails.lastName,
          postcode: '46000',
          state: city,
          region_code: "",
          region_id: 0,
          phone_number: "+38" + this.personalDetails.phoneNumber,
          shipping_carrier_code: "anywhere",
          shipping_method_code: "anywhere"
        }
        order.quote_id = this.$store.state.cart.cartServerToken ? this.$store.state.cart.cartServerToken : '',
        order.cutlery_qty = [{
          partner: this.partner.code,
          qty: 1
        }]
        order.deliveryTime = [{
          asap: true,
          datetime: "",
          partner: this.partner.code,
          replaceOutOfStock: "call",
          shippingMethod: "delivery"
        }]
        order.shippingMethods = [{
          method: {
            carrier_code: "freeshipping",
            method_code: "freeshipping",
            method_title: "Безкоштовна доставка"
          },
          partner: this.partner.code
        }]
        this.$store.dispatch('pickup-checkout/placeOrder', { order }).then(() => {
          this.showThankYouPage = true;
          this.personalDetails = {
              firstName: '',
              lastName: '',
              phoneNumber: '',
              emailAddress: ''
          };
          this.selectedInsurance= '';
          this.$v.$reset();
          localStorage.removeItem('shop/user/insurance');
        })
      }
    },
    checkPhoneCountry (phone) {
      if (phone.length > 10 && phone.substr(0, 3) === '+38') {
        return phone.substr(3)
      } else if (phone.length === 10) {
        return phone
      }
      return ''
    },
    saveInStorage () {
      let info = this.personalDetails
      info.insurance = this.selectedInsurance
      localStorage.setItem('shop/user/insurance', JSON.stringify(info));
    }
  },
  destroyed () {
    this.showThankYouPage = false;
    this.$store.dispatch('partners/resetCurrentPartner');
  }
}
</script>
<style lang="scss" scoped>
  .fs18 {
    font-size: 18px;
  }
  .insurance-link {
    color: #11bb2e;
  }
  .w-100-mobile {
    @media (max-width: 576px) {
      width: 100%;
    }
  }
</style>
<style lang="scss">
  .insurance .select-wrapper select {
    border: 1px solid #bdbdbd!important;
    border-radius: 5px!important;
    padding: 0 10px!important;
    background: #fff!important;
  }
  .insurance-description {
    p {
      margin: 0;
      text-align: start;
    }
  }
</style>
